import { render, staticRenderFns } from "./UpTestPaper.vue?vue&type=template&id=5b37eec7&scoped=true&"
import script from "./UpTestPaper.vue?vue&type=script&lang=js&"
export * from "./UpTestPaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37eec7",
  null
  
)

export default component.exports